import logoKOTR from "../../assets/img/historicEvents/LogoNetworkSpecials/KOTR.png";
import logoBITE from "../../assets/img/historicEvents/LogoNetworkSpecials/BITE.png";
import logoLFMSG from "../../assets/img/historicEvents/LogoNetworkSpecials/LFMSG.png";
import logoRB from "../../assets/img/historicEvents/LogoNetworkSpecials/RB.png";
import logoCC from "../../assets/img/historicEvents/LogoNetworkSpecials/CC.png";
import logoUKT from "../../assets/img/historicEvents/LogoNetworkSpecials/2017-2018UKT.png";
import logoUKS from "../../assets/img/historicEvents/LogoNetworkSpecials/UKS.png";
import logoMYC from "../../assets/img/historicEvents/LogoNetworkSpecials/MYC.png";
import logoStarrcade1718 from "../../assets/img/historicEvents/LogoNetworkSpecials/2017-2018starrcade.png";
import logoMYC2018 from "../../assets/img/historicEvents/LogoNetworkSpecials/2018MYC.png";
import logoWC2019 from "../../assets/img/historicEvents/LogoNetworkSpecials/2019WC.png";
import logoSFC from "../../assets/img/historicEvents/LogoNetworkSpecials/SFC.png";
import logoSV from "../../assets/img/historicEvents/LogoNetworkSpecials/SV.png";
import logoStarrcade2019 from "../../assets/img/historicEvents/LogoNetworkSpecials/2019Starrcade.png";
import logoWC2020 from "../../assets/img/historicEvents/LogoNetworkSpecials/2020WC.png";

export const networkSpecialsDetail = {
  "network-specials": {
    id: "network-specials",
    title: "WWE Network Specials",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "network-specials",
        items: [
          {
            id: "network-specials-kotr-2015",
            title: "King of the Ring",
            description: "2015",
            imgUrl: logoKOTR,
          },
          {
            id: "network-specials-bite-2015",
            title: "The Beast in the East",
            description: "Brock Lesnar Live from Tokio 2015",
            imgUrl: logoBITE,
          },
          {
            id: "network-specials-lfmsg-2015",
            title: "WWE Live from MSG",
            description:
              "Lesnar Vs. Big Show 2015",
            imgUrl: logoLFMSG,
          },
          {
            id: "network-specials-roadblock-2016",
            title: "WWE Roadblock",
            description:
              "Road Closed Ahead 2016",
            imgUrl: logoRB,
          },
          {
            id: "network-specials-cruiserweight-classic-2016",
            title: "Cruiserweight Classic",
            description:
              "2016",
            imgUrl: logoCC,
          },
          {
            id: "network-specials-ukt-2017",
            title: "United Kingdom Championship Tournament",
            description:
              "2017",
            imgUrl: logoUKT,
          },
          {
            id: "network-specials-uk-special-2017",
            title: "United Kingdom Championship Special",
            description:
              "2017",
            imgUrl: logoUKS,
          },
          {
            id: "network-specials-myc-2017",
            title: "Mae Young Classic",
            description:
              "2017",
            imgUrl: logoMYC,
          },
          {
            id: "network-specials-starrcade-2017",
            title: "Starrcade",
            description:
              "2017",
            imgUrl: logoStarrcade1718,
          },
          {
            id: "network-specials-ukt-2018",
            title: "United Kingdom Championship Tournament",
            description:
              "2018",
            imgUrl: logoUKT,
          },
          {
            id: "network-specials-myc-2018",
            title: "Mae Young Classic",
            description:
              "2018",
            imgUrl: logoMYC2018,
          },
          {
            id: "network-specials-starrcade-2018",
            title: "Starrcade",
            description:
              "2018",
            imgUrl: logoStarrcade1718,
          },
          {
            id: "network-specials-worlds-collide-2019",
            title: "Worlds Collide",
            description:
              "NXT UK Vs. NXT Vs. 205 Live 2019",
            imgUrl: logoWC2019,
          },
          {
            id: "network-specials-shield-final-chapter-2019",
            title: "The Shield's Final Chapter",
            description:
              "2019",
            imgUrl: logoSFC,
          },
          {
            id: "network-specials-smackville-2019",
            title: "Smackville",
            description:
              "2019",
            imgUrl: logoSV,
          },
          {
            id: "network-specials-starrcade-2019",
            title: "Starrcade",
            description:
              "2019",
            imgUrl: logoStarrcade2019,
          },
          {
            id: "network-specials-worlds-collide-2020",
            title: "Worlds Collide",
            description:
              "NXT Vs. NXT UK 2020",
            imgUrl: logoWC2020,
          },
        ],
      },
    ],
  },
};
